module.exports = __webpack_public_path__ + "img/fonos-camioneros.e91b4fd4.png";